
  import { mapGetters } from 'vuex';
  import { Address } from '@/scripts/address';
  import { ADDRESS_FIELDS, COUNTIES, RAW_ADDRESS_FIELDS } from '@/constants/addresses';

  export default {
    props: {
      addressKey: { type: String, default: 'default' },
      allowManualInput: { type: Boolean, default: true },
      autoFocus: { type: Boolean, default: false },
      disableEdit: { type: Boolean, default: false },
      submitOnValidEircode: { type: Boolean, default: false }
    },
    data () {
      return {
        addressFields: ADDRESS_FIELDS,
        counties: COUNTIES,
        editable: false,
        navIndex: 0,
        previousSearch: '',
        rawAddressFields: RAW_ADDRESS_FIELDS,
        results: [],
        searchTerm: '',
        state: 'search',
        uuid: this.$uuid.v4()
      };
    },
    computed: {
      ...mapGetters('utils', { addressGetter: 'getAddress' }),
      address () {
        return this.addressGetter(this.addressKey) || {};
      },
      canonicalAddress () {
        return this.address ? new Address(this.address).canonical : null;
      },
      toggles () {
        if (this.state === 'search' && this.allowManualInput) {
          return [{ action: 'edit', key: 'enter' }];
        } else if (this.state === 'display') {
          return [{ action: 'edit', key: 'edit' }, { action: 'search', key: 'reset' }];
        } else if (this.state === 'edit') {
          return [{ action: 'search', key: 'reset' }];
        }
        return [];
      }
    },
    created () {
      if (this.submitOnValidEircode) {
        this.$store.commit('utils/clearAddress', this.addressKey);
      }
      if (this.canonicalAddress && Object.keys(this.canonicalAddress).length > 1) {
        this.state = 'display';
      }
    },
    mounted () {
      if (this.autoFocus) {
        const input = this.$el.querySelector(`#search-${this.addressKey}`);
        if (input) {
          input.focus();
        }
      }
    },
    methods: {
      focusInput () {
        this.$nextTick(() => {
          const input = this.$el.querySelector('input');
          if (input) {
            input.focus();
          }
        });
      },
      inputAttrs (field) {
        return {
          disabled: field === 'eircode' && !this.allowManualInput,
          id: ['search', this.addressKey, field].join('-'),
          placeholder: this.$t(`placeholders.${field}`)
        };
      },
      move (dir) {
        this.navIndex = Math.max(0, this.navIndex + dir);
      },
      reset () {
        this.searchTerm = '';
        this.results = [];
        this.$store.commit('utils/clearAddress', this.addressKey);
      },
      required (field) {
        return ['addr_line1', 'county'].includes(field); // Only add1, county, and eircode required in manual address
      },
      search () {
        if (this.searchTerm.length > 4 && this.searchTerm !== this.previousSearch) {
          this.previousSearch = this.searchTerm;
          this.$api('util/eircodes', { address: this.searchTerm }).then(r => {
            this.results = r;
          });
        }
      },
      select (address) {
        if (address) {
          this.$store.commit('utils/setAddress', { ...address, ...{ key: this.addressKey } });
          this.state = 'display';
          this.validate();
          this.searchTerm = address.full_address;
          if (this.submitOnValidEircode) {
            this.$emit('addressSelect', address);
          }
        }
      },
      setTerm (val) {
        this.searchTerm = val;
        this.search();
      },
      setToggle (newState) {
        if (newState === 'edit' && this.state === 'search') {
          this.reset();
        }
        this.state = newState;
        if (newState === 'search') {
          this.reset();
        }
        this.focusInput();
      },
      validate () {
        const addressError = this.validateAddress() ? '' : this.$t('errors.addressNotCompleted');
        const addressInput = this.$el.querySelector('[data-field="address"] input');
        if (addressInput) {
          addressInput.setCustomValidity(addressError);
        }
      },
      validateAddress () {
        return this.canonicalAddress && this.canonicalAddress.add1 && this.canonicalAddress.add1.length && this.canonicalAddress.county;
      }
    }
  };
